export default "__VITE_ASSET__1BymcMJs__"